export const ADMIN_ROLES_LIST_ACTIONS = {
    ADMIN_ROLES_LIST_REQUEST: "ADMIN_ROLES_LIST_REQUEST",
    ADMIN_ROLES_LIST_RESPONSE: "ADMIN_ROLES_LIST_RESPONSE",
    ADMIN_ROLES_LIST_ERROR: "ADMIN_ROLES_LIST_ERROR",
  };